module.exports = __webpack_public_path__ + "img/header.00b0cccd.png";